// extracted by mini-css-extract-plugin
export var actionButton = "_5r-1";
export var actionButtons = "_5r-2";
export var actions = "_5r-0";
export var aiUnread = "_5r-10";
export var alignCenter = "_5r-h";
export var backWrapper = "_5r-3";
export var cellContainer = "_5r-4";
export var checkboxContainer = "_5r-5";
export var contentContainer = "_5r-6";
export var contentHeader = "_5r-8";
export var conversationsTableWrapper = "_5r-s";
export var draftReplyBadgeContainer = "_5r-m";
export var dropdownItem = "_5r-b";
export var dropdownItemsContainer = "_5r-a";
export var dropdownTitle = "_5r-c";
export var errorIcon = "_5r-7";
export var filter = "_5r-d";
export var gray = "_5r-i";
export var headerActionButtons = "_5r-e";
export var headerCheckboxContainer = "_5r-f";
export var icon = "_5r-j";
export var menuContainer = "_5r-k";
export var noMoreTicketsIcon = "_5r-12";
export var noMoreTicketsSubText = "_5r-13";
export var oneLine = "_5r-l";
export var optionsButton = "_5r-n";
export var plus = "_5r-o";
export var portalButtonsWrapper = "_5r-g";
export var red = "_5r-p";
export var scrolledTop = "_5r-9";
export var search = "_5r-q";
export var selectedConversationsCount = "_5r-r";
export var spinner = "_5r-t";
export var strong = "_5r-u";
export var summaryCell = "_5r-v";
export var tableContainer = "_5r-11";
export var tagContainer = "_5r-w";
export var threeDots = "_5r-x";
export var twoLines = "_5r-y";
export var unread = "_5r-z";